import requestFunctions from "../../functions/requestFunctions";


export const state = {
  CURRENCY_ITEM: {},
  CURRENCY_LIST: [],
  CURRENCY_TABLE_DATA: [],
  CURRENCY_ARRAY_DATA: [],
  CURRENCY_TOTAL_ROWS: 0
}

export const getters = {
  GET_CURRENCY_ITEM: (state) => {
    return state.CURRENCY_ITEM;
  },
  GET_CURRENCY_LIST: (state) => {
    return state.CURRENCY_LIST;
  },
  GET_CURRENCY_TABLE_DATA: (state) => {
    return state.CURRENCY_TABLE_DATA;
  },
  GET_CURRENCY_ARRAY_DATA: (state) => {
    return state.CURRENCY_ARRAY_DATA;
  },
  GET_CURRENCY_TOTAL_ROWS: (state) => {
    return state.CURRENCY_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_CURRENCY_ITEM(state, item) {
    state.CURRENCY_ITEM = item;
  },

  UPDATE_CURRENCY_LIST(state, list) {
    
    state.CURRENCY_LIST = list.data;

    state.CURRENCY_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.CURRENCY_TABLE_DATA = [];
    state.CURRENCY_ARRAY_DATA = [];

    list.forEach(el => {

      let status = '';

      if(el.status === 'active')  { status = 'Активна' }
      if(el.status === 'wait')    { status = 'Ожидается' }
      if(el.status === 'paused')  { status = 'Приостановлена' }
      if(el.status === 'blocked') { status = 'Заблокирована' }
      if(el.status === 'stopped') { status = 'Остановлена' }

      state.CURRENCY_TABLE_DATA.push({
        'name' : el.name,
        'code' : el.code,
        'balance_code': el.balance_code,
        'uuid' : el.uuid,
        'default_commission': el.default_commission,
        'last_rate': el.last_rate,
        'status' : status,
        'id'   : el.id,
      });

      state.CURRENCY_ARRAY_DATA.push({
        id: el.id,
        name: el.name,
        code: el.code,
        balance_code: el.balance_code,
        uuid: el.uuid,
        status: el.status
      });
    });
  },
}

export const actions = {

  async FETCH_CURRENCY_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/currency/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CURRENCY_ITEM', response.data);
      return response.data;
    }
  },

  async FETCH_CURRENCY_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/currency';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_CURRENCY_LIST', response.data);
      return response.data;
    }
  },

  async FETCH_CURRENCY_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/currency';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_CURRENCY_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/currency/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },

  async FETCH_CURRENCY_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/currency/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }
  },
}